import {doGet, doPost} from "./ApiService";
export const BASE_URL = process.env.REACT_APP_API_SEARCH_DOC || '/api';

export const getSuggestedFolders = (query) => {
    return doGet(`${BASE_URL}/document-search/suggested-folders`, query)
}

export const getAdvancedFilters = (query) => {
    return doGet(`${BASE_URL}/document-search/advanced-filters`, query)
}

export const getRecentDocuments = (query) => {
    return doGet(`${BASE_URL}/document-search/recent-documents`, query)
}

export const findAllDocuments = (query) => {
    return doPost(`${BASE_URL}/document-search`, query)
}

export const getFilterDomains = () => {
    return doGet(`${BASE_URL}/domains`)
}

export const getFilters = () => {
    return doGet(`${BASE_URL}/domains/fields`)
}

export const searchDocEvent = (query) => {
    return doGet(`${BASE_URL}/document-event`, query)
}